module.exports = __webpack_public_path__ + "static/media/right-outline.ed8fb2d9.svg";